export default {
  aggregates: {
    aggregated: 'Verzamelde resultaten',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'geleden',
    from: 'van',
    since: 'sinds',
    unit: {
      DAY: 'dag|dagen',
      MONTH: 'maand|maanden',
      YEAR: 'jaar|jaren'
    },
    untilNow: 'tot nu'
  },
  categoryDetails: {
    average: 'Gemiddelde:',
    chartLabel: {
      noLabel: 'Nee',
      yesLabel: 'Ja'
    },
    description:
      'Dit laat zien hoe de antwoorden van het team op alle vragen in de categorie zijn verdeeld.',
    hideOwnAnswers: 'Verberg eigen antwoorden',
    noResponses: 'Geen antwoorden',
    notParticipating: 'Je hebt deze vraag zelf niet beantwoord.',
    numberOfPeople: 'Antwoorden:',
    sensitiveQuestion: 'Alleen zichtbaar voor jou als manager.',
    showFollowUpQuestions: 'Toon vervolgvragen',
    toggleButton: {
      overview: 'Overzicht',
      questions: 'Vragen'
    },
    tooltip: {
      barValue: 'niemand | {count} persoon | {count} personen',
      barValueAnswers: 'niemand | {count} antwoord | {count} antwoorden'
    },
    workWith: 'Verbeter {categoryName}',
    yourResponse: 'Jij hebt geantwoord:'
  },
  error: {
    couldNotLoadAggregates: 'Kon verzamelde resultaten niet laden.',
    couldNotLoadResults: 'Kon resultaten niet laden.',
    networkError:
      'Er ging iets mis bij het laden van de gegevens. Heb je een werkende internetverbinding?',
    unknown: 'Er is een onbekende fout'
  },
  errors: {
    status: {
      BadRequest: 'Fout bij serveraanvraag',
      Forbidden: 'Het is niet toegestaan ​​om toegang te krijgen tot deze bron',
      InternalServerError:
        'Er is iets misgegaan op de server. Neem contact op met het supportteam als dit probleem aanhoudt.',
      NotFound: 'Kon niet vinden wat u zocht',
      Unauthorized: 'U bent niet bevoegd om toegang te krijgen tot deze bron',
      UnknownError: 'Er is een onbekende fout opgetreden'
    }
  },
  freetext: {
    loadResponses: 'Antwoorden laden',
    noFreeTextQuestions:
      'Wanneer u in uw enquête vragen met vrij in te vullen tekst heeft, ziet u hier alle antwoorden.',
    notEnoughResponses: 'Niet genoeg antwoorden',
    responses: 'Geen antwoorden |{count} antwoord | {count} antwoorden'
  },
  general: {
    add: 'Toevoegen',
    cancel: 'Annuleren',
    entireOrganization: 'Hele organisatie',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} is de gemiddelde waarde voor vragen binnen {title}. {compareToBenchmark}',
    currentValue: 'Huidige waarde',
    filter: {
      findGroups: 'Vind groepen',
      shouldExportWithHierarchy: 'Inclusief onderliggende groepen'
    },
    loadMore: 'Meer laden',
    loadMoreInGroup: 'Laad meer onder {groupName}',
    noone: 'Er heeft niemand gereageerd',
    noResults:
      'Nog niet genoeg reacties vanuit deze groep. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'hebben gereageerd',
    nps: 'Netto PromotorScore',
    nps_detractors: 'Critici',
    nps_passives: 'Toekijkers',
    nps_promoters: 'Promotors',
    questions: 'Vragen binnen categorie',
    showTrend: 'Verandering weergeven',
    violationsIn:
      'Er is gerapporteerd dat er schendingen hebben plaatsgevonden binnen {groupName}. Neem contact op met de HR-afdeling. Zij kunnen je meer vertellen en je helpen het probleem op te lossen.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected:
        'Selecteer een datum als startpunt voor de geschiedenis.',
      selectDate:
        'Zou de geschiedenis moeten weergeven van enquêtes sinds {datum}.',
      selectedDate: 'Geeft geschiedenis van enquêtes weer sinds {datum}.'
    },
    selectorOptions: {
      custom: 'aangepast',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Probeer opnieuw'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Huidige enquêtes',
    help: 'Help',
    myActivities: 'Acties',
    ourResults: 'Resultaten',
    overview: 'Overzicht',
    team: 'Team',
    welcome: 'Welkom'
  },
  page: {
    results: 'Alle resultaten'
  },
  resultDetails: {
    backToResults: 'Ga terug',
    exportData: 'Exporteren',
    exportModal: {
      includeSensitiveQuestions: 'Gevoelige vragen opnemen',
      loadingMessage: 'Exporteren van gegevens voorbereiden, even geduld!',
      saveAsExcelAllGroupsDescription:
        'Als u exporteert naar Excel, krijgt u een bestand met resultaten voor {groupTitle} en alle onderliggende groepen. Dit is handig als u uw eigen multi-groepsanalyses of -berekeningen wilt uitvoeren.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Als u exporteert naar Excel, krijgt u een bestand met resultaten voor {groupTitle}{segmentInfo}. Dit is handig als u uw eigen analyses of berekeningen wilt uitvoeren.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'U ontvangt een PDF-document met de resultaten voor alle categorieën en vragen voor de geselecteerde groep. Handig als u de resultaten wilt afdrukken.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'Met een PowerPoint-export krijgt u een mooie presentatie met resultaten voor {groupTitle}{segmentInfo}. Ideaal als u uw resultaten op een groot scherm aan anderen wilt laten zien.'
    },
    notes: {
      draggable: {
        explanation: 'Alleen zichtbaar voor jou',
        placeholder:
          'Noteer hier uw eigen aantekeningen, opmerkingen en gedachten over de enquête',
        title: 'Persoonlijke notities'
      },
      status: {
        initial: 'Automatisch opslaan terwijl u typt',
        saved: 'Wijzigingen opgeslagen!',
        unsaved: 'Wordt zo meteen opgeslagen...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Er zijn niet genoeg reacties om de resultaten per gebruiker weer te geven'
        },
        description: {
          high: 'Er heeft één persoon gereageerd waardoor zijn of haar gemiddelde score groen werd |Er hebben {count} mensen gereageerd waardoor hun gemiddelde score groen werd.',
          low: 'Er heeft één persoon gereageerd waardoor zijn of haar gemiddelde score rood werd |Er hebben {count} mensen gereageerd waardoor hun gemiddelde score rood werd.',
          medium:
            'Er heeft één persoon gereageerd waardoor zijn of haar gemiddelde score geel werd.|Er hebben {count} mensen gereageerd waardoor hun gemiddelde score geel werd.'
        },
        title: 'Niemand|Eén persoon|{count} mensen'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Jouw score is dezelfde als de Pulsᐩ benchmark® voor {title}.',
        higherThanBenchmarkValue:
          'Jouw score is {benchmarkDiff} hoger dan de Pulsᐩ benchmark® voor {title} die {benchmarkValue} is. Goed zo!',
        lowerThanBenchmarkValue:
          'Je bent {benchmarkDiff} lager dan de Pulsᐩ benchmark® voor {title} die {benchmarkValue} is',
        percentagePoints: 'procentpunten'
      },
      enps: {
        button: {
          description:
            'Je wordt doorverwezen naar onze partner, EQI, die referentiegegevens verzamelt voor een groot aantal organisaties en een meer gedetailleerd inzicht geeft betreffende je eigen eNPS-score.',
          title: 'Vergelijk jouw eNPS-score met andere organisaties'
        }
      },
      toggleButton: {
        history: 'Geschiedenis',
        overview: 'Overzicht'
      }
    }
  },
  results: {
    aggregated: 'Geaggregeerd',
    chooseSurvey: 'Selecteer enquête',
    finished: 'Voltooid',
    published: 'Lopend'
  },
  resultsmessages: {
    disclaimer: 'Pulsᐩ AI gebruikt generatieve AI en kan fouten maken.',
    error: {
      generic:
        'Oei... er gaat iets niet zoals verwacht. Probeer de pagina opnieuw te laden.',
      notEnoughResults:
        'Er zijn geen resultaten om het over te hebben. Selecteer een andere groep of enquête om Pulsᐩ AI te gebruiken.'
    },
    moreInfo: 'Leer hoe u Pulsᐩ AI als leider kunt gebruiken',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Stel een vraag over resultaten...',
    reload: 'Pagina opnieuw laden',
    report: 'Probleem oplossen',
    send: 'Versturen',
    suggestionHeader:
      'Hier zijn enkele suggesties voor vragen die u kunt stellen:',
    suggestions: {
      groupsComparison: {
        1: 'Op welke groepen moet ik me concentreren?',
        2: 'Is er een vraag waar de meeste groepen aan moeten werken?',
        3: 'Welke groepen vertonen negatieve trends?',
        4: 'Welke groepen hebben positieve trends?',
        5: 'Welke groepen onderscheiden zich negatief?',
        6: 'Welke groepen hebben mijn aandacht nodig?',
        7: 'Wat moet ik eerst doen?'
      },
      overview: {
        1: 'Wat moet ik doen met ons resultaat?',
        2: 'Hoe moet ik het resultaat aan mijn team presenteren?',
        3: 'Hoe zien de resultaten er in het algemeen uit?',
        4: 'Wat zijn de top 3 acties die we moeten ondernemen?',
        5: 'Wat kan ik verbeteren in mijn leiderschap?',
        6: "Welke risico's lopen we?",
        7: 'Wat kan er gebeuren als we niets doen?',
        8: 'Wat moet ik prioriteit geven?',
        9: 'Wat is de prognose voor mijn team?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Iedereen'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Vergelijken'
        },
        export: {
          title: 'Exporteren'
        },
        freetext: {
          title: 'Vrij in te vullen tekst'
        },
        results: {
          title: 'Enquêteresultaten'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Het is niet mogelijk om statistieken te tonen zonder het risico te lopen de anonimiteit te verliezen.',
    others: 'Overige| Overigen',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administratie',
    currentSurveys: 'Huidige onderzoeken',
    dashboard: 'Dashboard',
    help: 'Hulp',
    logOut: 'Uitloggen',
    myActivities: 'Mijn acties',
    ourResults: 'Onze resultaten'
  },
  topbanner: {
    preview: {
      body: 'U bekijkt nu de nieuwe versie van de Pulsᐩ-resultatenweergave, die vele verbeteringen bevat! Als u iets tegenkomt dat niet goed werkt of als u feedback heeft, laat het ons dan weten! U kunt ook overschakelen naar de oude versie als u dat wilt.',
      header: 'Nieuwe versie!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Gedurende de periode {startDate} - {endDate} is het resultaat voor {categoryName} gedaald.',
        trend_increased:
          'Gedurende de periode {startDate} - {endDate} is het resultaat voor {categoryName} toegenomen. Ga zo door met het goede werk!',
        trend_same:
          'Het resultaat is hetzelfde gebleven voor {categoryName} gedurende de periode {startDate} - {endDate}.'
      }
    },
    noTrend: 'Er is geen ouder onderzoek om mee te vergelijken.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'In vergelijking met het vorige onderzoek op {oldSurveyDate} is het resultaat voor {tagName} gedaald met {changeInPercent}%.',
        nps_trend_increased:
          'In vergelijking met het vorige onderzoek op {oldSurveyDate} is het resultaat voor {tagName} gestegen met {changeInPercent}%.',
        nps_trend_same:
          'Het resultaat voor {tagName} is sinds het vorige onderzoek op {oldSurveyDate} ongeveer gelijk gebleven met een wijziging van {changeInPercent}%.',
        trend_decreased:
          'Gedurende de periode {startDate} - {endDate} is het resultaat voor {tagName} gedaald.',
        trend_increased:
          'Gedurende de periode {startDate} - {endDate} is het resultaat verhoogd voor {tagName}',
        trend_same:
          'Het resultaat is hetzelfde gebleven voor {categoryName} gedurende de periode {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Alle groepen',
    cannotChangeGroupsWhileComparing:
      'In de vergelijkingsweergave bekijkt u meerdere groepen tegelijk.',
    group: 'Groep',
    segment: 'Segment',
    survey: 'Enquête'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Aantal mensen dat minimaal een actie heeft geselecteerd',
      totalActions: 'Totaal aantal geselecteerde acties'
    },
    title: 'Overzicht van handelingen'
  },
  widgetAlert: {
    actions: {
      saved: 'Bedankt, de activiteit is opgeslagen.'
    },
    links: {
      tooltip: 'De link opent in een nieuw venster'
    },
    notEnoughData: 'Er valt hier nu niets te tonen.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Meest recent gerapporteerd {surveyDate}.'
      },
      question: {
        info: 'Meest recent gevraagd {surveyDate} in "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Er zijn nog niet genoeg reacties om hier iets weer te geven.',
    title: 'Categorieën',
    tooltip: {
      value:
        'Dit is de gemiddelde waarde voor alle reacties op vragen binnen {categoryName} en beantwoord door mensen in {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Er is een onverwachte fout opgetreden tijdens het laden van de widget. Probeer eerste de pagina opnieuw te laden. Als het probleem zich blijft voordoen, meld dit dan aan ons, dan gaan we er meteen naar kijken!',
    hideErrorDetails: 'Verberg foutdetails',
    showErrorDetails: 'Toon foutdetails',
    title: 'Probleem in widget!'
  },
  widgetGroupActions: {
    allCategories: 'Binnen alle categorieën',
    freeText: {
      alert: {
        noResults: 'Niets gevonden. Probeer iets anders te typen',
        typeMore: 'Typ iets meer'
      },
      filterField: {
        placeholder: 'Typ om reacties te vinden'
      },
      numberOfComments: '{numberOfComments} reacties'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title:
          'Hoe persoonlijke verantwoordelijkheid bij werknemers te ontwikkelen'
      }
    },
    noActions: 'Geen acties om weer te geven.',
    noActionsSelectedInCategory: 'Er zijn geen acties gekozen',
    otherActions: 'Eigen acties',
    people: 'niemand | {count} persoon | {count} personen',
    peopleSelectedActions:
      'Van {peopleResponded} mensen die hebben gereageerd heeft slecht 1 minimaal een actie geslecteerd ({percentage}%)| Van {peopleResponded} mensen die hebben gereageerd, hebben {count} mensen minimaal één actie geslecteerd ({percentage}%)',
    title: 'Gekozen acties voor mensen in {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 persoon koos deze actie| {count} mensen kozen deze actie'
    }
  },
  widgetGroupPriorities: {
    description:
      'Dit zijn volgens de deelnemers aan het onderzoek de belangrijkste onderwerpen om je nu op te richten.',
    freeTextResponses: 'Geef vrije tekstreacties weer',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Hoe je je team kunt ontwikkelen met Pulsᐩ'
      }
    },
    noPriorities: 'Er zijn geen prioriteiten gekozen door de deelnemers.',
    people: 'niemand | {count} persoon | {count} personen',
    thinkImportant: ' vinden dat "{category}" het belangrijkst is',
    title: 'Prioriteiten voor mensen in {groupName}'
  },
  widgetNotImplemented: {
    content: 'Nog niet geïmplementeerd'
  },
  widgetSurveyInfo: {
    endDate: 'Einddatum:',
    noone: 'Er heeft niemand gereageerd',
    notEnoughResponses: {
      aggregate:
        'Er hebben in de betreffende periode niet genoeg mensen deelgenomen om resultaten te kunnen tonen.',
      completed:
        'Niet genoeg mensen hebben de enquête ingevuld om resultaten te kunnen tonen.',
      published:
        'De enquête is nog niet door genoeg mensen ingevuld om resultaten te kunnen tonen.'
    },
    participation: {
      title: 'Deelname'
    },
    startDate: 'Startdatum:',
    status: {
      completed:
        'Het onderzoek is voltooid! Dit zijn de definitieve resultaten.',
      published: 'Het onderzoek loopt nog. De resultaten zijn voorlopig.'
    },
    usersInvited: 'Mensen uitgenodigd:',
    usersResponded: 'Ontvangen reacties:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Dit zijn de meest recente resultaten voor {groupName}.'
    },
    notEnoughResponses:
      'Er zijn nog niet genoeg reacties om hier iets weer te geven.',
    title: {
      company: 'Heel {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS staat voor Netto PromotorScore van Werknemers en meet in hoeverre werknemers het werken binnen hun bedrijf willen promoten.',
      nps_description:
        'NPS staat voor Netto PromotorScore en meet hoe groot de kans is dat mensen iets aan anderen aanbevelen.',
      nps_detractors: 'Critici',
      nps_passives: 'Toekijkers',
      nps_promoters: 'Promotors',
      value:
        'Dit is de gemiddelde waarde voor alle reacties op vragen getagd met {tagName} en beantwoord door mensen in {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} gedurende de tijd',
    twoTags: '{tag1} en {tag2}'
  }
}
